module.exports = __webpack_public_path__ + "static/img/IMG_0447.fd4f540.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fotosGaleriaSicarf/IMG_0447.jpg
// module id = s7dD
// module chunks = 12